var map = {
	"./E@2x.png": 41,
	"./ENE@2x.png": 42,
	"./ESE@2x.png": 43,
	"./N@2x.png": 44,
	"./NE@2x.png": 45,
	"./NNE@2x.png": 46,
	"./NNW@2x.png": 47,
	"./NW@2x.png": 48,
	"./S@2x.png": 49,
	"./SE@2x.png": 50,
	"./SSE@2x.png": 51,
	"./SSW@2x.png": 52,
	"./SW@2x.png": 53,
	"./W@2x.png": 54,
	"./WNW@2x.png": 55,
	"./WSW@2x.png": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;